import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { SYSTEM_CATEGORIES } from './salesData';
export function SystemSection() {
  return <section id="sistema" className="bg-charcoal py-14 sm:py-24" aria-labelledby="system-title" data-id="element-233" data-mp="3biwmv1oypcb4">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-8" data-id="element-234" data-mp="36jsf8fhormmw">
        <div className="grid gap-8 lg:grid-cols-12 lg:gap-14" data-id="element-235" data-mp="36jaep6nzqm96">
          <div className="lg:col-span-5" data-id="element-236" data-mp="31kz1clyhltm7">
            <SectionTag tone="dark" data-id="element-237" data-mp="31m0eqx2z6s73">La solución</SectionTag>
            <h2 id="system-title" className="mt-4 font-display text-[1.6rem] uppercase leading-[1.06] text-ivory sm:text-[2.5rem]" data-id="element-238" data-mp="2wtqv1ysgeod9">
              8 kits. Un solo sistema para tu consultorio.
            </h2>
            <p className="mt-5 max-w-md font-sans text-[0.9rem] leading-relaxed text-ivory/65 sm:text-base" data-id="element-239" data-mp="2nr7trj4bgjt4">
              No es un ebook genérico sobre Inteligencia Artificial. Es un sistema práctico dividido
              en 8 áreas para incorporar IA a tareas reales del trabajo nutricional.
            </p>
          </div>

          <ul className="grid grid-cols-2 gap-2.5 sm:grid-cols-4 sm:gap-3 lg:col-span-7 lg:self-center" data-id="element-240" data-mp="18poe32flaogi">
            {SYSTEM_CATEGORIES.map((category, index) => <motion.li key={category} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.5
          }} transition={{
            duration: 0.26,
            ease: [0.23, 1, 0.32, 1],
            delay: Math.min(index, 7) * 0.03
          }} className="flex flex-col justify-between rounded-2xl border border-ivory/12 bg-charcoal-soft px-3.5 py-4 sm:aspect-square sm:px-4" data-id="element-241" data-mp="tyxl3r29hjbt" data-mpi={index}>
                <span className="font-sans text-[0.6rem] font-bold tabular-nums text-gold" aria-hidden data-id="element-242" data-mp="1c3bjp6zg4d4">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <span className="mt-4 font-display text-[0.88rem] uppercase leading-tight text-ivory sm:mt-0 sm:text-[1rem]" data-id="element-243" data-mp="28ymo37ww8l6n">
                  {category}
                </span>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}